/**
 * @file useGetSiteSettings.js
 */
import { useQuery } from "@apollo/client";
import { GET_SITE_SETTINGS } from "cache/SiteSettings/queries";

/**
 * @hook useGetSiteSettings
 *
 * @description Fetches the singleton site settings document.
 */
const useGetSiteSettings = () => {
	const { loading, error, data, refetch, networkStatus } = useQuery(GET_SITE_SETTINGS);

	const settings = data?.getSiteSettings;

	return { loading, error, data: settings, refetch, networkStatus };
};

export default useGetSiteSettings;
